import { isEnum } from "../validation/index.mjs";
export var AlignableBlock;

(function (AlignableBlock) {
  var Alignment;

  (function (Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["CENTER"] = "center";
    Alignment["RIGHT"] = "right";
  })(Alignment = AlignableBlock.Alignment || (AlignableBlock.Alignment = {}));

  function validateAlignableBlock(value) {
    var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (value === null) return null;

    if (required) {
      var _isValid = isEnum(value.align, Alignment);

      return _isValid ? value : null;
    }

    var isValid = !('align' in value) || isEnum(value.align, Alignment);
    return isValid ? value : null;
  }

  AlignableBlock.validateAlignableBlock = validateAlignableBlock;
})(AlignableBlock || (AlignableBlock = {}));